<template>
  <div class="d-flex align-items-center">
    <span v-for="n in 5" :key="n" class="text-warning me-1">
      <font-awesome-icon
        :icon="n <= value ? 'star' : ['far', 'star']"
        :class="n <= value ? 'fas' : ''"
        size="2x"
      />
    </span>
    <p class="text-muted">({{ value }})</p>
  </div>
</template>

<script>
export default {
  name: "Rating",
  props: {
    value: {
      type: Number,
      required: true,
      validator: (val) => Number.isInteger(val) && val >= 0 && val <= 5,
    },
  },
};
</script>
